export default __webpack_public_path__ + "static/media/avatar_xiao_mei2.0c440b7b.mp3";